import { _mock } from "./_mock";

export const _installers = [...Array(21)].map((_, index) => ({
  id: index,
  name: _mock.fullName(index),
  avatarUrl: _mock.image.avatar(index),
}));